import React from "react";
import {
  StudentPortfolioSvg,
  SchoolPolicy,
  ScopeAndSequenceSvg,
  TeacherResourcesSvg,
  FamilyCommunicationIcon,
  PremiumFeaturesIcon,
} from "SvgComponents";
import {
  CalendarScheduleOutlined,
  CalendarScheduleWeekOutlined,
  UnitLibraryOutlined,
  LeLibraryOutlined,
  ClassSettingsOutlined,
  NotificationSettingsOutlined,
  FamilyOutlined,
  FolderOutlined,
  ClassProgressOutlined,
  OpenBookOutlined,
  DashboardOutlined,
  SettingsOutlined,
  UnitPlanOutlined,
  AssessmentEvaluatedOutlined,
  JournalOutlined,
  ProgressReportOutlined,
  AssessmentandEvaluationOutlined,
  PolicyTickOutlined,
  TeacherResourceOutlined,
  InsightsSquareOutlined,
  CommentMultipleOutlined,
  AttendanceOutlined,
  AssessmentOutlined,
  TickFrameOutlined,
  InternalAssessmentOutlined,
  ExternalAssessmentOutlined,
  SpiralBookLinesOutlined,
  GoalsOutlined,
  DeleteOutlined,
  TableOutlined,
  AssessmentApplicableOutlined,
  PresentationOutlined,
  CalendarScheduleYearOutlined,
  WorksheetClipboardOutlined,
  SortOutlined,
  ClockArrowsOutlined,
  ScienceOutlined,
  HomeOutlined,
  QuickTaskOutlined,
} from "@toddle-edu/ds-icons";
import {
  ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  CLASS_DRIVE_ACCESS_PERMISSION,
  ASSIGNMENTS_ACCESS_PERMISSION,
  CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
  PLANNING_INSIGHTS_COURSE_LEVEL_VIEW_PERMISSION,
  CLASS_FLOW_VIEW_PERMISSION,
  CLASS_PLANNER_PERMISSION,
  WEEKLY_SCHEDULER_PERMISSION,
  PSOW_ROEP_ACCESS_PERMISSION,
  PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  SUBJECT_SETTINGS_ACCESS_PERMISSION,
  CLASS_SETTINGS_ACCESS_PERMISSION,
  CLASS_RECYCLE_BIN_ACCESS_PERMISSION,
  ATTENDANCE_ACCESS_PERMISSION,
  ENABLE_UNIT_PLAN_PERMISSION,
  COURSE_GRADEBOOK_ACCESS_PERMISSION,
  CAN_VIEW_CONTINUUM_MODULE_SETTING,
  CAN_VIEW_IA_EA_MODULE,
  SHOW_COURSE_HOMEPAGE_FOR_STUDENT_PORTAL,
  SHOW_COURSE_HOMEPAGE_FOR_PARENT_PORTAL,
  CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
  CAN_VIEW_CLASS_ANNOUNCEMENT_MODULE,
  CAN_VIEW_LTI_TOOLS_CONFIG,
  CAN_VIEW_LTI_TOOLS,
  ENABLE_STUDENT_TIMETABLE_PERMISSION,
} from "Constants/permissionConstants";
import {
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
  PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
} from "Constants/stringConstants";

export const TeacherMenu = {
  teacherPoralIBPYPFreemiumRootNodes: [
    "UNIT_PLANS",
    "PREMIUM_FEATURES",
    "FREEMIUM_SETTINGS",
  ],

  // default teacher
  defaultTeacherNodeId: "UNIT_PLANS",

  // default student
  defaultPYPStudentNodeId: "CLASS_ROOM",
  defaultMYPStudentNodeId: "CLASS_ROOM_MYP",
  defaultUBDStudentNodeId: "CLASS_ROOM_UBD",

  // default parent
  defaultParentNodeId: "JOURNAL",

  // teacher root nodes
  teacherPortalIBPYPRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "CLASS_PROGRESS",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "PROGRESS_REPORT_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],

  teacherPortalIBMYPRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "CLASS_PROGRESS",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],

  teacherPortalESFMasterClassRootNodes: [
    "PLANNING",
    "CLASS_PROGRESS",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
  ],
  teacherPortalESFNonMasterClassRootNodes: [
    "CLASSROOM",
    "UBD_CLASS",
    "CLASS_PROGRESS",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
  ],

  teacherPortalUBDRootNodes: [
    "PLANNING",
    "UBD_CLASS",
    "CLASS_PROGRESS",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  teacherPortalIBDPRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "CLASS_PROGRESS",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  teacherPortalIBDPCASRootNodes: [
    "CLASSROOM",
    "PROJECT_GROUP",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPTOKRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "PROJECT_GROUP",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPEERootNodes: [
    "CLASSROOM",
    "PROJECT_GROUP",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPLDRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "PROJECT_GROUP",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPPPSRootNodes: [
    "PLANNING",
    "CLASSROOM",
    "GRADEBOOK",
    "GRADEBOOK_CAS",
    "GRADEBOOK_V2",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "PROJECT_GROUP",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPRPRootNodes: [
    "CLASSROOM",
    "PROJECT_GROUP",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPSLRRootNodes: [
    "CLASSROOM",
    "PROJECT_GROUP",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  teacherPortalIBDPCERootNodes: [
    "CLASSROOM",
    "PROJECT_GROUP",
    "CONTINUUM_V2",
    "WORKFLOWS",
    "EDUCATOR_CENTER",
    "SETTINGS_V2",
    "SETTINGS",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],

  // student root nodes
  studentPortalIBPYPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "JOURNAL",
    "ROUTINES",
    "STUDENT_DRIVE",
    "STUDENT_CENTER",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  studentPortalIBMYPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM_MYP",
    "CLASS_MATERIALS",
    "MYP_JOURNAL",
    "MYP_ROUTINES",
    "STUDENT_DRIVE",
    "STUDENT_CENTER",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  studentPortalUBDRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM_UBD",
    "CLASS_MATERIALS",
    "UBD_JOURNAL",
    "UBD_ROUTINES",
    "STUDENT_DRIVE",
    "STUDENT_CENTER",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  studentPortalIBDPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "PROJECT_GROUP",
    "STUDENT_DRIVE",
    "DP_SUBJECT_JOURNAL",
    "DP_ROUTINES",
    "PRACTICAL_ACTIVITIES",
    "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
    "STUDENT_CENTER",
    "LTI_TOOLS",
    "ANNOUNCEMENT",
  ],
  studentPortalIBDPCASRootNodes: [
    "HOME",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "PROJECT_GROUP",
    "STUDENT_DRIVE",
    "DP_ROUTINES",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  studentPortalIBDPTOKRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "PROJECT_GROUP",
    "STUDENT_DRIVE",
    "DP_ROUTINES",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],
  studentPortalIBDPEERootNodes: [
    "HOME",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "PROJECT_GROUP",
    "STUDENT_DRIVE",
    "DP_ROUTINES",
    "ANNOUNCEMENT",
    "LTI_TOOLS",
  ],

  // parent root nodes
  parentPortalIBPYPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "CLASSPLANNERS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "JOURNAL",
    "ROUTINES",
    "PARENT_CENTER",
    "STUDENT_DRIVE",
    "ANNOUNCEMENT",
  ],
  parentPortalIBMYPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "CLASSPLANNERS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM_MYP",
    "CLASS_MATERIALS",
    "MYP_JOURNAL",
    "MYP_ROUTINES",
    "PARENT_CENTER",
    "STUDENT_DRIVE",
    "ANNOUNCEMENT",
  ],
  parentPortalUBDRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "CLASSPLANNERS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM_UBD",
    "CLASS_MATERIALS",
    "UBD_JOURNAL",
    "UBD_ROUTINES",
    "PARENT_CENTER",
    "STUDENT_DRIVE",
    "ANNOUNCEMENT",
  ],
  parentPortalIBDPRootNodes: [
    "HOME",
    "UNIT_PLANS",
    "CLASSPLANNERS",
    "COURSE_FLOW",
    "COURSE_PLAN",
    "CLASS_ROOM",
    "CLASS_MATERIALS",
    "PROJECT_GROUP",
    "DP_SUBJECT_JOURNAL",
    "DP_ROUTINES",
    "PARENT_CENTER",
    "STUDENT_DRIVE",
    "ANNOUNCEMENT",
  ],

  nodes: [
    {
      id: "PREMIUM_FEATURES",
      label: "teacherHomePage:premium_features",
      children: ["SCHEDULER", "PORTFOLIO_REPORTS", "FAMILY_COMMUNICATION"],
      levelId: "L0",
      icon: <PremiumFeaturesIcon />,
      isBottom: false,
    },
    {
      id: "PROJECT_GROUP",
      label: "{{projectGroupType}}",
      //by default we are applying t fn to the label. So to not apply t fn we need to pass this boolean.
      isLabelNotLocalized: true,
      isBottom: false,
      children: [],
      route: "projects/:projectGroupId",
      levelId: "L1",
      icon: <StudentPortfolioSvg />,
      permission: CAN_VIEW_IA_EA_MODULE,
      isDynamicNode: true,
      dynamicNodeConfig: {
        //this id will replace the id of the node
        id: "PROJECT_GROUP_{{projectGroupType}}",
        type: "PROJECT_GROUP",
        iconConfig: [
          {
            icon: <InternalAssessmentOutlined variant={"on"} />,
            type: PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
          },
          {
            icon: <ExternalAssessmentOutlined variant={"on"} />,
            type: PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
          },
        ],
      },
    },
    {
      id: "LTI_TOOLS",
      label: "classRoom:lti_tool_plural",
      levelId: "L0",
      children: [],
      icon: <ScienceOutlined variant={"on"} />,
      iconForNewSidebar: <ScienceOutlined variant="on" />,
      studentPerm: CAN_VIEW_LTI_TOOLS_CONFIG,
      perm: CAN_VIEW_LTI_TOOLS,
      isBottom: false,
    },
    {
      id: "HOME",
      label: "common:home",
      children: [],
      route: "home",
      levelId: "L0",
      isBottom: false,
      icon: <HomeOutlined variant={"on"} />,
      studentPerm: SHOW_COURSE_HOMEPAGE_FOR_STUDENT_PORTAL,
      parentPerm: SHOW_COURSE_HOMEPAGE_FOR_PARENT_PORTAL,
    },
    // --------------------------------------LTI Tools Options Object--------------------------------------

    // {
    //   id: "ONENOTE",
    //   label: "OneNote",
    //   levelId: "L1",
    //   route: "lti-tools/onenote",
    //   icon: <TeacherResourceOutlined variant="on" />,
    //   perm: "Common:EnableOnenoteLTITool",
    //   studentPerm: "Common:EnableOnenoteLTITool",
    //   isBottom: false,
    // },

    // fututre LTI tools can be added here

    // {
    //   id: "MCGRAWHILL",
    //   label: "McGraw Hill",
    //   levelId: "L1",
    //   route: "lti-tools/mcgrawhill",
    //   icon: <ScopeAndSequenceSvg />,
    //   perm: "Common:EnableMcGrawHillLTITool",
    //   studentPerm: "Common:EnableOnenoteLTITool",
    //   isBottom: false,
    // },

    // --------------------------------------LTI Tools Options Object Ends--------------------------------------

    {
      id: "PLANNING",
      label: "teacherHomePage:planning",
      children: [
        "UNIT_PLANS",
        "CLASSPLANNERS",
        "SCHEDULER",
        "PLANNING_INSIGHTS",
        "SCOPE_SEQUENCE",
        // "MY_CALENDAR"
      ],
      curriculumIBMYPChildren: [
        "UNIT_PLANS",
        "CLASSPLANNERS",
        "SCHEDULER_MYP",
        "PLANNING_INSIGHTS",
        "MYP_LEARNING_STANDARDS",
        // "MY_CALENDAR"
      ],
      curriculumUBDChildren: [
        "UNIT_PLANS",
        "CLASSPLANNERS",
        "SCHEDULER_UBD",
        "PLANNING_INSIGHTS",
        "UBD_LEARNING_STANDARDS",
      ],
      curriculumDPChildren: [
        "UNIT_PLANS",
        "CLASSPLANNERS",
        "SCHEDULER_DP",
        "DP_SUBJECT_STANDARD",
        "DP_PLANNING_INSIGHTS",
      ],
      levelId: "L0",
      icon: <CalendarScheduleOutlined variant={"on"} />,
      iconForNewSidebar: <PresentationOutlined variant="on" />,
      isBottom: false,
    },
    {
      id: "DP_SUBJECT_STANDARD",
      label: "common:content_standards",
      children: [],
      levelId: "L1",
      route: "dp-learning-standards",
      icon: <ScopeAndSequenceSvg />,
      perm: "TeacherPortal:DPLearningStandards",
    },
    {
      id: "MYP_LEARNING_STANDARDS",
      label: "common:content_standards",
      children: [],
      levelId: "L1",
      route: "learning-standards",
      icon: <ScopeAndSequenceSvg />,
      plannerElementType: "MYP_LEARNING_STANDARD",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      perm: "TeacherPortal:MYPLearningStandards",
    },
    {
      id: "UBD_LEARNING_STANDARDS",
      label: "common:content_standards",
      children: [],
      levelId: "L1",
      route: "ubd-learning-standards",
      icon: <ScopeAndSequenceSvg />,
      plannerElementType: "UBD_LEARNING_STANDARD",
      isDynamicPlannerElementLabel: true,
      perm: "TeacherPortal:UBDLearningStandards",
    },
    {
      id: "CLASSROOM",
      label: "teacherHomePage:classRoom",

      children: [
        "CLASS_ROOM",
        "CLASS_MATERIALS",
        "MYP_JOURNAL",
        "ROUTINES",
        "STUDENT_DRIVE",
        "ATTENDANCE",
      ],
      curriculumIBMYPChildren: [
        "CLASS_ROOM_MYP",
        "CLASS_MATERIALS",
        "MYP_JOURNAL",
        "MYP_ROUTINES",
        "STUDENT_DRIVE",
        "ATTENDANCE",
      ],
      curriculumDPChildren: [
        "CLASS_ROOM_DP",
        "CLASS_MATERIALS",
        "PROJECT_GROUP",
        "PRACTICAL_ACTIVITIES",
        "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
        "STUDENT_DRIVE",
        "ATTENDANCE_DP",
        "DP_SUBJECT_JOURNAL",
        "DP_ROUTINES",
      ],
      // Only for Core classes (CAS, EE, TOK)
      curriculumDPCoreChildren: [
        "CLASS_ROOM_DP",
        "CLASS_MATERIALS",
        "STUDENT_DRIVE",
        "ATTENDANCE_DP",
        "DP_ROUTINES",
      ],

      route: "studentPortfolioReport",
      levelId: "L0",
      icon: <CommentMultipleOutlined variant={"on"} />,
      iconForNewSidebar: <OpenBookOutlined variant="on" />,
      isBottom: false,
    },
    {
      id: "UBD_CLASS",
      label: "teacherHomePage:classRoom",
      curriculumUBDChildren: [
        "CLASS_ROOM_UBD",
        "CLASS_MATERIALS",
        "UBD_JOURNAL",
        "UBD_ROUTINES",
        "STUDENT_DRIVE",
        "ATTENDANCE",
      ],

      levelId: "L0",
      icon: <CommentMultipleOutlined variant={"on"} />,
      iconForNewSidebar: <OpenBookOutlined variant="on" />,
      isBottom: false,
    },

    {
      id: "FAMILY_COMMUNICATION",
      label: "configuration:family_messaging",
      children: [],
      route: "familyconversations",
      levelId: "L1",
      icon: <FamilyCommunicationIcon />,
      isBottom: false,
      perm: "TeacherPortal:FamilyCommunication",
    },

    {
      id: "ATTENDANCE",
      label: "teacherHomePage:attendance",
      children: [],
      route: "attendance",
      levelId: "L0",
      isBottom: false,
      icon: <AttendanceOutlined variant={"on"} />,
      permission: ATTENDANCE_ACCESS_PERMISSION,
    },

    {
      id: "ATTENDANCE_DP",
      label: "teacherHomePage:attendance",
      children: [],
      route: "attendance",
      levelId: "L0",
      isBottom: false,
      icon: <AttendanceOutlined variant={"on"} />,
      permission: ATTENDANCE_ACCESS_PERMISSION,
    },
    // --------------------------------------Classroom--------------------------------------
    {
      id: "CLASS_ROOM",
      label: "common:assignments",
      icon: <AssessmentOutlined variant={"on"} />,
      children: [],
      route: "classroom",
      levelId: "L0",
      isBottom: false,
      permission: ASSIGNMENTS_ACCESS_PERMISSION,
    },
    {
      id: "CLASS_ROOM_MYP",
      label: "common:assignments",
      icon: <AssessmentOutlined variant={"on"} />,
      children: [],
      route: "classroom",
      levelId: "L0",
      isBottom: false,
      permission: ASSIGNMENTS_ACCESS_PERMISSION,
    },
    {
      id: "CLASS_ROOM_UBD",
      label: "common:assignments",
      icon: <AssessmentOutlined variant={"on"} />,
      children: [],
      route: "classroom",
      levelId: "L0",
      isBottom: false,
      permission: ASSIGNMENTS_ACCESS_PERMISSION,
    },
    {
      id: "CLASS_ROOM_DP",
      label: "common:assignments",
      icon: <AssessmentOutlined variant={"on"} />,
      children: [],
      route: "classroom",
      levelId: "L0",
      isBottom: false,
      permission: ASSIGNMENTS_ACCESS_PERMISSION,
    },
    // --------------------------------------Class flow--------------------------------------
    {
      id: "CLASS_MATERIALS",
      label: "teacherHomePage:class_materials",
      children: [],
      route: "class-flow",
      levelId: "L1",
      isBottom: false,
      icon: <DashboardOutlined variant={"on"} />,
      permission: CLASS_FLOW_VIEW_PERMISSION,
    },
    // --------------------------------------Course flow--------------------------------------
    {
      id: "COURSE_FLOW",
      label: "course:course_flow_lower",
      children: [],
      route: "course-flow",
      levelId: "L1",
      isBottom: false,
      icon: <DashboardOutlined variant={"on"} />,
      permission: CLASS_FLOW_VIEW_PERMISSION,
    },
    // --------------------------------------Course plan--------------------------------------
    {
      id: "COURSE_PLAN",
      label: "course:course_flow_lower",
      children: [],
      route: "course-plan",
      levelId: "L1",
      isBottom: false,
      icon: <DashboardOutlined variant={"on"} />,
      permission: CLASS_FLOW_VIEW_PERMISSION,
    },
    // --------------------------------------Announcements--------------------------------------
    {
      id: "ANNOUNCEMENT",
      label: "announcement:class_announcements",
      children: [],
      route: "circulars",
      levelId: "L1",
      isBottom: false,
      icon: <QuickTaskOutlined variant="on" />,
      permission: CAN_VIEW_CLASS_ANNOUNCEMENT_MODULE,
    },
    // --------------------------------------Settings--------------------------------------
    {
      id: "SETTINGS",
      label: "common:settings",
      levelId: "L0",
      isBottom: false,
      icon: <SettingsOutlined variant={"on"} />,
      perm: "TeacherPortal:ShowOldClassSetting",
      studentPerm: "StudentPortal:ClassSetting",
      // route: "settings",
      children: [
        "CLASS_SETTINGS",
        "NOTIFICATION_SETTINGS",
        "MANAGE_FAMILY",
        "TIMETABLE_CONFIGURATION",
      ],
      curriculumIBMYPChildren: ["MANAGE_FAMILY", "TIMETABLE_CONFIGURATION"],
      curriculumUBDChildren: ["MANAGE_FAMILY", "TIMETABLE_CONFIGURATION"],
      curriculumDPChildren: ["MANAGE_FAMILY", "TIMETABLE_CONFIGURATION"],
      // Only for Core classes (CAS, EE, TOK)
      curriculumDPCoreChildren: ["TIMETABLE_CONFIGURATION"],
    },
    {
      id: "SETTINGS_V2",
      label: "common:settings",
      levelId: "L0",
      isBottom: false,
      isFooterMenu: true,
      icon: <SettingsOutlined variant={"on"} />,
      route: "class-settings",
      children: ["CLASS_SETTINGS_V2", "PYP_SUBJECT_SETTINGS", "RECYCLE_BIN"],
      permission: CLASS_SETTINGS_ACCESS_PERMISSION,
      isDynamicNode: true,
      dynamicNodeConfig: {
        id: "CLASS_SETTINGS",
        type: "CLASS_SETTINGS",
        labelConfig: {
          [CURRICULUM_TYPE_PYP]: "common:class_settings",
          [CURRICULUM_TYPE_MYP]: "common:class_settings",
        },
      },
      curriculumIBMYPChildren: [
        "CLASS_SETTINGS_V2",
        "SUBJECT_SETTINGS",
        "RECYCLE_BIN",
      ],
      curriculumUBDChildren: [
        "CLASS_SETTINGS_V2",
        "SUBJECT_SETTINGS",
        "RECYCLE_BIN",
      ],
      curriculumDPChildren: [
        "CLASS_SETTINGS_V2",
        "SUBJECT_SETTINGS",
        "RECYCLE_BIN",
      ],
      curriculumDPCASOrEEChildren: ["CLASS_SETTINGS_V2", "RECYCLE_BIN"],
    },
    {
      id: "FREEMIUM_SETTINGS",
      label: "common:settings",
      levelId: "L0",
      isBottom: false,
      icon: <SettingsOutlined variant={"on"} />,
      route: "subject-settings",
      children: ["RECYCLE_BIN"],
      permission: CLASS_RECYCLE_BIN_ACCESS_PERMISSION,
      isDynamicNode: true,
      dynamicNodeConfig: {
        id: "RECYCLE_BIN",
        type: "RECYCLE_BIN",
        labelConfig: {
          [CURRICULUM_TYPE_PYP]: "common:recycle_bin",
          [CURRICULUM_TYPE_MYP]: "common:recycle_bin",
        },
      },
      curriculumIBMYPChildren: ["RECYCLE_BIN"],
      curriculumUBDChildren: ["RECYCLE_BIN"],
      curriculumDPChildren: ["RECYCLE_BIN"],
      curriculumDPCASOrEEChildren: [],
    },
    {
      id: "CLASS_SETTINGS_V2",
      label: "common:class_settings",
      levelId: "L1",
      isBottom: false,
      icon: <ClassSettingsOutlined variant="on" />,
      children: [],
      route: "class-settings",
      permission: CLASS_SETTINGS_ACCESS_PERMISSION,
    },
    {
      id: "SUBJECT_SETTINGS",
      label: "common:subject_settings",
      levelId: "L1",
      isBottom: false,
      icon: <SpiralBookLinesOutlined variant="on" />,
      iconForNewSidebar: <SortOutlined variant="on" />,
      children: [],
      route: "subject-settings",
      permission: SUBJECT_SETTINGS_ACCESS_PERMISSION,
    },
    {
      id: "RECYCLE_BIN",
      label: "common:recycle_bin",
      levelId: "L1",
      isBottom: false,
      icon: <DeleteOutlined variant="on" />,
      children: [],
      route: "recycle-bin",
      permission: CLASS_RECYCLE_BIN_ACCESS_PERMISSION,
    },
    {
      id: "PYP_SUBJECT_SETTINGS",
      label: "common:subject_settings",
      levelId: "L1",
      isBottom: false,
      icon: <SpiralBookLinesOutlined variant="on" />,
      children: [],
      route: "subject-settings",
      permission: SUBJECT_SETTINGS_ACCESS_PERMISSION,
    },
    {
      id: "CLASS_SETTINGS",
      label: "common:class_settings",
      levelId: "L1",
      isBottom: false,
      icon: <ClassSettingsOutlined variant="on" />,
      perm: ["TeacherPortal:ClassSetting", "TeacherPortal:ShowOldClassSetting"],
      studentPerm: "StudentPortal:ClassSetting",
      children: [],
      route: "settings",
    },
    {
      id: "NOTIFICATION_SETTINGS",
      label: "configuration:notifications_preferences",
      levelId: "L1",
      isBottom: false,
      icon: <NotificationSettingsOutlined variant="on" />,
      perm: [
        "Common:NotificationConfiguration",
        "TeacherPortal:ShowOldClassSetting",
      ],
      studentPerm: "Common:NotificationConfiguration",
      children: [],
      route: "notification-preferences",
    },
    {
      id: "MANAGE_FAMILY",
      label: "common:manage_family_members",
      levelId: "L1",
      isBottom: false,
      icon: <FamilyOutlined variant="on" />,
      perm: [
        "TeacherPortal:ManageFamilyMembers",
        "TeacherPortal:ShowOldClassSetting",
      ],
      children: [],
      route: "manage-family",
    },
    {
      id: "TIMETABLE_CONFIGURATION",
      label: "common:timetable_config",
      levelId: "L1",
      isBottom: false,
      icon: <SettingsOutlined variant={"on"} />,
      perm: [
        ENABLE_STUDENT_TIMETABLE_PERMISSION,
        "TeacherPortal:ShowOldClassSetting",
      ],
      children: [],
      route: "timetable-configuration",
    },

    {
      id: "EDUCATOR_CENTER",
      label: "teacherHomePage:educator_center_sentence_case",
      children: [
        "TEACHER_SCHOOL_POLICIES",
        "PARENT_SCHOOL_POLICIES",
        "STUDENT_SCHOOL_POLICIES",
        "TEACHER_RESOURCE",
        "STUDENT_RESOURCE",
        "PARENT_RESOURCE",
        "UNIT_LIBRARY",
        "LE_LIBRARY_PYP",
      ],
      curriculumIBMYPChildren: [
        "TEACHER_SCHOOL_POLICIES",
        "PARENT_SCHOOL_POLICIES",
        "STUDENT_SCHOOL_POLICIES",
        "TEACHER_RESOURCE",
        "STUDENT_RESOURCE",
        "PARENT_RESOURCE",
        "UNIT_LIBRARY",
        "LE_LIBRARY_MYP",
      ],
      curriculumUBDChildren: [
        "TEACHER_SCHOOL_POLICIES",
        "PARENT_SCHOOL_POLICIES",
        "STUDENT_SCHOOL_POLICIES",
        "TEACHER_RESOURCE",
        "STUDENT_RESOURCE",
        "PARENT_RESOURCE",
        "UNIT_LIBRARY",
        "LE_LIBRARY_UBD",
      ],
      curriculumDPChildren: [
        "TEACHER_SCHOOL_POLICIES",
        "PARENT_SCHOOL_POLICIES",
        "STUDENT_SCHOOL_POLICIES",
        "TEACHER_RESOURCE",
        "STUDENT_RESOURCE",
        "PARENT_RESOURCE",
        "UNIT_LIBRARY",
        "LE_LIBRARY_DP",
      ],
      levelId: "L0",
      icon: <OpenBookOutlined variant={"on"} />,
      isBottom: false,
    },
    {
      id: "PARENT_CENTER",
      label: "teacherHomePage:parent_center_sentence_case",
      children: ["PARENT_SCHOOL_POLICIES", "PARENT_RESOURCE"],
      curriculumIBMYPChildren: ["PARENT_SCHOOL_POLICIES", "PARENT_RESOURCE"],
      curriculumUBDChildren: ["PARENT_SCHOOL_POLICIES", "PARENT_RESOURCE"],
      curriculumDPChildren: ["PARENT_SCHOOL_POLICIES", "PARENT_RESOURCE"],
      levelId: "L0",
      icon: <OpenBookOutlined variant={"on"} />,
      isBottom: false,
    },
    {
      id: "STUDENT_CENTER",
      label: "teacherHomePage:student_center_sentence_case",
      children: ["STUDENT_SCHOOL_POLICIES", "STUDENT_RESOURCE"],
      curriculumIBMYPChildren: ["STUDENT_SCHOOL_POLICIES", "STUDENT_RESOURCE"],
      curriculumUBDChildren: ["STUDENT_SCHOOL_POLICIES", "STUDENT_RESOURCE"],
      curriculumDPChildren: ["STUDENT_SCHOOL_POLICIES", "STUDENT_RESOURCE"],
      levelId: "L0",
      icon: <OpenBookOutlined variant={"on"} />,
      isBottom: false,
    },
    {
      id: "UNIT_PLANS",
      label: "teacherHomePage:staff_perm_units_of_inquiry",
      studentLabel: "teacherHomePage:units",
      parentLabel: "teacherHomePage:units",
      children: [],
      levelId: "L1",
      route: "unitPlans",
      icon: <UnitPlanOutlined variant={"on"} />,
      permission: ENABLE_UNIT_PLAN_PERMISSION,
      isBottom: false,
    },
    {
      id: "PLANNING_INSIGHTS",
      label: "teacherHomePage:planning_insights",
      children: [],
      levelId: "L1",
      route: "planningInsights",
      icon: <InsightsSquareOutlined variant={"on"} />,
      permission: PLANNING_INSIGHTS_COURSE_LEVEL_VIEW_PERMISSION,
      isBottom: false,
    },
    {
      id: "DP_PLANNING_INSIGHTS",
      label: "teacherHomePage:planning_insights",
      children: [],
      levelId: "L1",
      route: "planningInsights",
      icon: <InsightsSquareOutlined variant={"on"} />,
      permission: PLANNING_INSIGHTS_COURSE_LEVEL_VIEW_PERMISSION,
      isBottom: false,
    },
    // --------------------------------------Class Planners--------------------------------------

    {
      id: "CLASSPLANNERS",
      label: "teacherHomePage:class_planners",
      children: [],
      levelId: "L1",
      route: "class-planners",
      icon: <GoalsOutlined variant="on" />,
      iconForNewSidebar: <CalendarScheduleYearOutlined variant="on" />,
      permission: CLASS_PLANNER_PERMISSION,
    },
    // --------------------------------------Scheduler--------------------------------------
    {
      id: "SCHEDULER",
      label: "teacherHomePage:weekly_yearly_planning",
      children: [],
      levelId: "L1",
      route: "scheduler",
      icon: <CalendarScheduleWeekOutlined variant="on" />,
      iconForNewSidebar: <CalendarScheduleYearOutlined variant="on" />,
      permission: WEEKLY_SCHEDULER_PERMISSION,
    },
    {
      id: "SCHEDULER_MYP",
      label: "teacherHomePage:weekly_planning",
      children: [],
      levelId: "L1",
      route: "scheduler",
      icon: <CalendarScheduleWeekOutlined variant="on" />,
      iconForNewSidebar: <CalendarScheduleYearOutlined variant="on" />,
      permission: WEEKLY_SCHEDULER_PERMISSION,
    },
    {
      id: "SCHEDULER_UBD",
      label: "teacherHomePage:weekly_planning",
      children: [],
      levelId: "L1",
      route: "scheduler",
      icon: <CalendarScheduleWeekOutlined variant="on" />,
      iconForNewSidebar: <CalendarScheduleYearOutlined variant="on" />,
      permission: WEEKLY_SCHEDULER_PERMISSION,
    },
    {
      id: "SCHEDULER_DP",
      label: "teacherHomePage:weekly_planning",
      children: [],
      levelId: "L1",
      route: "scheduler",
      icon: <CalendarScheduleWeekOutlined variant="on" />,
      iconForNewSidebar: <CalendarScheduleYearOutlined variant="on" />,
      permission: WEEKLY_SCHEDULER_PERMISSION,
    },
    {
      id: "SCOPE_SEQUENCE",
      label: "common:content_standards",
      children: [],
      levelId: "L1",
      route: "scopeandsequence",
      icon: <AssessmentEvaluatedOutlined variant={"on"} />,
      perm: "TeacherPortal:ScopeAndSequance",
      dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
    },
    // --------------------------------------Journal--------------------------------------
    {
      id: "JOURNAL",
      label: "teacherHomePage:class_portfolio",
      children: [],
      route: "journal",
      levelId: "L1",
      icon: <JournalOutlined variant={"on"} />,
      permission: CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
    },
    {
      id: "MYP_JOURNAL",
      label: "teacherHomePage:portfolio",
      children: [],
      route: "journal",
      levelId: "L1",
      icon: <JournalOutlined variant={"on"} />,
      permission: CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
    },
    {
      id: "UBD_JOURNAL",
      label: "teacherHomePage:portfolio",
      children: [],
      route: "journal",
      levelId: "L1",
      icon: <JournalOutlined variant={"on"} />,
      permission: CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
    },
    {
      id: "DP_SUBJECT_JOURNAL",
      label: "teacherHomePage:portfolio",
      children: [],
      route: "journal",
      levelId: "L1",
      icon: <JournalOutlined variant={"on"} />,
      permission: CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
    },
    {
      id: "ROUTINES",
      label: "journal:routines",
      children: [],
      route: "routines",
      levelId: "L1",
      icon: <ClockArrowsOutlined variant={"on"} />,
      permission: CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
    },
    {
      id: "MYP_ROUTINES",
      label: "journal:routines",
      children: [],
      route: "routines",
      levelId: "L1",
      icon: <ClockArrowsOutlined variant={"on"} />,
      permission: CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
    },
    {
      id: "UBD_ROUTINES",
      label: "journal:routines",
      children: [],
      route: "routines",
      levelId: "L1",
      icon: <ClockArrowsOutlined variant={"on"} />,
      permission: CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
    },
    {
      id: "DP_ROUTINES",
      label: "journal:routines",
      children: [],
      route: "routines",
      levelId: "L1",
      icon: <ClockArrowsOutlined variant={"on"} />,
      permission: CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
    },
    {
      id: "ASSESSMENT_EVALUATION",
      label: "teacherHomePage:assess_learning",
      children: [],
      route: "assessmentEvaluation",
      levelId: "L1",
      icon: <AssessmentandEvaluationOutlined variant={"on"} />,
      perm: "TeacherPortal:AssessmentEvaluation",
      isBottom: false,
    },
    {
      id: "CONTINUUM",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L1",
      icon: <TickFrameOutlined variant={"on"} />,
      permission: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      isBottom: false,
    },
    {
      id: "CONTINUUM_V2",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L0",
      icon: <TickFrameOutlined variant={"on"} />,
      permission: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      isBottom: false,
    },
    {
      id: "CONTINUUM_MYP",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L1",
      icon: <TickFrameOutlined variant={"on"} />,
      permission: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      isBottom: false,
    },
    {
      id: "CONTINUUM_UBD",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L1",
      icon: <TickFrameOutlined variant={"on"} />,
      permission: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      isBottom: false,
    },
    {
      id: "CONTINUUM_DP",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L1",
      icon: <TickFrameOutlined variant={"on"} />,
      permission: CAN_VIEW_CONTINUUM_MODULE_SETTING,
      isBottom: false,
    },
    {
      id: "PROGRESS_REPORT",
      label: "teacherHomePage:progress_report",
      children: [],
      route: "progressreport",
      levelId: "L1",
      icon: <ProgressReportOutlined variant={"on"} />,
      perm: "TeacherPortal:ProgressReport",
      rolesAndPermission: {
        moduleName: "PROGRESS_REPORTS",
        accessCondition: accessModule => {
          return {
            rule: "gt",
            value: accessModule.values.NO_ACCESS.id,
          };
        },
      },
    },
    {
      id: "PROGRESS_REPORT_V2",
      label: "teacherHomePage:progress_report",
      children: [],
      route: "progressreport",
      levelId: "L0",
      icon: <ProgressReportOutlined variant={"on"} />,
      permission: PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "CLASS_PROGRESS",
      label: "teacherHomePage:class_progress_sentence_case",
      children: [
        "PROGRESS_REPORT",
        "GRADEBOOK",
        "ASSESSMENT_EVALUATION",
        "CONTINUUM",
      ],
      curriculumIBMYPChildren: ["GRADEBOOK", "CONTINUUM_MYP"],
      curriculumUBDChildren: ["GRADEBOOK", "CONTINUUM_UBD"],
      curriculumDPChildren: ["CONTINUUM_DP"],
      levelId: "L0",
      icon: <ClassProgressOutlined variant={"on"} />,
    },
    {
      id: "GRADEBOOK",
      label: "common:gradebook",
      children: [],
      levelId: "L0",
      icon: <TableOutlined variant="on" />,
      route: "gradebook",
      permission: COURSE_GRADEBOOK_ACCESS_PERMISSION,
    },
    {
      id: "GRADEBOOK_CAS",
      label: "common:gradebook",
      children: [],
      levelId: "L0",
      icon: <TableOutlined variant="on" />,
      route: "gradebook",
      perm: ["Common:GradebookForCAS"],
    },
    {
      id: "GRADEBOOK_V2",
      label: "common:gradebook",
      children: ["ASSESSMENT_GRADEBOOK", "LEARNING_GOALS_GRADEBOOK"],
      curriculumIBMYPChildren: [
        "ASSESSMENT_GRADEBOOK",
        "LEARNING_GOALS_GRADEBOOK",
        "PROGRESS_REPORT_OVERVIEW",
      ],
      curriculumUBDChildren: [
        "ASSESSMENT_GRADEBOOK",
        "LEARNING_GOALS_GRADEBOOK",
      ],
      curriculumDPChildren: [
        "ASSESSMENT_GRADEBOOK",
        "LEARNING_GOALS_GRADEBOOK",
      ],
      curriculumDPCASOrEEChildren: [
        "CAS_ASSESSMENT_GRADEBOOK",
        "CAS_LEARNING_GOALS_GRADEBOOK",
      ],
      levelId: "L0",
      icon: <TableOutlined variant="on" />,
    },
    {
      id: "ASSESSMENT_GRADEBOOK",
      label: "common:assessment_gradebook",
      children: [],
      levelId: "L1",
      icon: <AssessmentApplicableOutlined variant={"on"} />,
      route: "gradebook/assessments",
      permission: COURSE_GRADEBOOK_ACCESS_PERMISSION,
    },
    {
      id: "LEARNING_GOALS_GRADEBOOK",
      label: "progressSummary:learning_goals_gradebook",
      children: [],
      levelId: "L1",
      icon: <GoalsOutlined variant={"on"} />,
      route: "gradebook/learning-goals",
      permission: COURSE_GRADEBOOK_ACCESS_PERMISSION,
    },
    {
      id: "PROGRESS_REPORT_OVERVIEW",
      label: "studentProgressSummary:progress_report_overview",
      children: [],
      levelId: "L1",
      icon: <WorksheetClipboardOutlined variant={"on"} />,
      route: "gradebook/progress-report-overview",
      perm: [
        "TeacherPortal:Gradebook",
        "FeatureFlag:EnableNewClassSidebar",
        "FeatureFlag:ShowProgressReportOverview",
      ],
    },
    {
      id: "CAS_ASSESSMENT_GRADEBOOK",
      label: "common:assessment_gradebook",
      children: [],
      levelId: "L1",
      icon: <AssessmentApplicableOutlined variant={"on"} />,
      route: "gradebook/assessments",
      perm: ["Common:GradebookForCAS"],
    },
    {
      id: "CAS_LEARNING_GOALS_GRADEBOOK",
      label: "progressSummary:learning_goals_gradebook",
      children: [],
      levelId: "L1",
      icon: <GoalsOutlined variant={"on"} />,
      route: "gradebook/learning-goals",
      perm: ["Common:GradebookForCAS"],
    },
    {
      id: "UNIT_LIBRARY",
      label: "teacherHomePage:unit_library_sentence_case",
      children: [],
      route: "unitlibrary",
      levelId: "L1",
      icon: <UnitLibraryOutlined variant="on" />,
      isBottom: true,
      perm: "TeacherPortal:UnitLibrary",
    },
    {
      id: "LE_LIBRARY_PYP",
      label: "teacherHomePage:learning_experience_library_sentence_case",
      children: [],
      route: "lelibrary",
      levelId: "L1",
      icon: <LeLibraryOutlined variant="on" />,
      perm: "TeacherPortal:LELibrary",
    },
    {
      id: "LE_LIBRARY_MYP",
      label:
        "teacherHomePage:learning_experience_&_assessment_library_sentence_case",
      children: [],
      route: "lelibrary",
      levelId: "L1",
      icon: <LeLibraryOutlined variant="on" />,
      perm: "TeacherPortal:LELibraryMyp",
    },
    {
      id: "LE_LIBRARY_UBD",
      label:
        "teacherHomePage:learning_experience_&_assessment_library_sentence_case",
      children: [],
      route: "lelibrary",
      levelId: "L1",
      icon: <LeLibraryOutlined variant="on" />,
      perm: "TeacherPortal:LELibraryUbd",
    },
    {
      id: "LE_LIBRARY_DP",
      label:
        "teacherHomePage:learning_experience_&_assessment_library_sentence_case",
      children: [],
      route: "lelibrary",
      levelId: "L1",
      icon: <LeLibraryOutlined variant="on" />,
      perm: "TeacherPortal:LELibraryDP",
    },
    {
      id: "TEACHER_SCHOOL_POLICIES",
      label: "teacherHomePage:school_policy",
      children: [],
      levelId: "L1",
      route: "teacherpolicies",
      icon: <PolicyTickOutlined variant={"on"} />,
      perm: "TeacherPortal:TeacherSchoolPolicies",
    },

    {
      id: "PARENT_SCHOOL_POLICIES",
      label: "teacherHomePage:school_policy",
      children: [],
      levelId: "L1",
      route: "parentpolicies",
      icon: <PolicyTickOutlined variant={"on"} />,
      parentPerm: "FamilyPortal:ParentSchoolPolicies",
    },

    {
      id: "STUDENT_SCHOOL_POLICIES",
      label: "teacherHomePage:school_policy",
      children: [],
      levelId: "L1",
      route: "studentpolicies",
      icon: <PolicyTickOutlined variant={"on"} />,
      studentPerm: "Common:StudentSchoolPolicies",
    },
    {
      id: "FAMILY_PORTAL_SCHOOL_POLICIES",
      label: "teacherHomePage:all_policies",
      children: [],
      levelId: "L1",
      route: "schoolpolicies",
      icon: <SchoolPolicy />,
      perm: "FamilyApp:SchoolPolicies",
    },
    {
      id: "TEACHER_RESOURCE",
      label: "teacherHomePage:teacher_resources_sentence_case",
      children: [],
      levelId: "L1",
      route: "teacherresources",
      icon: <TeacherResourceOutlined variant={"on"} />,
      perm: "TeacherPortal:TeacherResources",
    },
    {
      id: "STUDENT_RESOURCE",
      label: "teacherHomePage:student_resources_sentence_case",
      children: [],
      levelId: "L1",
      route: "studentresources",
      icon: <TeacherResourceOutlined variant={"on"} />,
      studentPerm: "Common:StudentResources",
    },
    {
      id: "PARENT_RESOURCE",
      label: "teacherHomePage:parent_resources_sentence_case",
      children: [],
      levelId: "L1",
      route: "parentresources",
      icon: <TeacherResourceOutlined variant={"on"} />,
      parentPerm: "Common:ParentResources",
    },

    {
      id: "ANNOUNCEMENTS",
      label: "teacherHomePage:announcements",
      children: [],
      levelId: "L1",
      route: "circulars",
      icon: <TeacherResourcesSvg />,
      isBottom: true,
      perm: "TeacherPortal:TeacherResources",
    },
    {
      id: "ADMIN_EDUCATOR_CENTER_V2",
      label: "common:school_policies_and_resources",
      children: [],
      levelId: "L1",
      route: "educatorcenter_v2",
      icon: <TeacherResourcesSvg />,
      isBottom: true,
      perm: "Common:EducatorCenterRevamp",
    },
    {
      id: "FAMILY_COMMUNICATIONS",
      label: "configuration:family_messaging",
      children: [],
      levelId: "L0",
      route: "familyconversations",
      icon: <FamilyCommunicationIcon />,
      isBottom: true,
      perm: "TeacherPortal:FamilyCommunications",
    },
    {
      id: "STUDENT_DRIVE",
      label: "common:class_files",
      children: [],
      route: "student-drive",
      levelId: "L1",
      icon: <FolderOutlined variant="on" />,
      permission: CLASS_DRIVE_ACCESS_PERMISSION,
    },
    {
      id: "PRACTICAL_ACTIVITIES",
      label: "project:practical_PSOW",
      children: [],
      route: "practicalactivities",
      levelId: "L1",
      icon: <AssessmentandEvaluationOutlined variant="on" />,
      permission: PSOW_ROEP_ACCESS_PERMISSION,

      isBottom: false,
      isDynamicNode: true,
      dynamicNodeConfig: {
        id: "PRACTICAL_ACTIVITIES",
        type: "PRACTICAL_ACTIVITIES",
      },
    },
    {
      id: "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
      label: "project:ROEP",
      children: [],
      route: "recordofexperimentalprogrammes",
      levelId: "L1",
      icon: <AssessmentandEvaluationOutlined variant="on" />,
      permission: PSOW_ROEP_ACCESS_PERMISSION,
      isBottom: false,
      isDynamicNode: true,
      dynamicNodeConfig: {
        id: "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
        type: "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
      },
    },
  ],
};
